import crypto from "crypto";

function getId(length = 10) {
  return crypto
    .randomBytes(Math.ceil(length / 2))
    .toString("hex")
    .slice(0, length);
}

export default getId;
